// extracted by mini-css-extract-plugin
module.exports = {"new":"view-default_new_1QwHj","dangerous":"view-default_dangerous_1iKUi"};